import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  items: ".animation--container > *",
  media: ".animation--image, .animation--video",
  mediaCaption: ".animation--media-caption",
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [selectors.media, selectors.mediaCaption]);
  delayOffset(node, [selectors.items], 6);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
